import { get } from '@namespace/helpers';

export const getBsBonusDetails = (bonusId) =>
  get(`/service/prewager/bonuses/${bonusId}`).then(
    ({ data: { campaign }, status, errorCode }) =>
      status === 'success'
        ? Promise.resolve(campaign)
        : Promise.reject(errorCode)
  );
